// extracted by mini-css-extract-plugin
export default {"overlay":"Xv-z","bodyOpen":"Yv-z","content":"Zv-z","header":"_v-z","close":"aw-z","closeNoHeading":"bw-z"};